import type {
  ComboboxOption,
  ComboboxOptions
} from '@library/components/selects';
import { Combobox } from '@library/components/selects';
import { FileHandler } from '@library/components/modals/FileUploaderModal/FileHandler';

export interface ResolutionUploaderProps {
  isError: boolean;
  onResolutionFileChange: (file: File | null) => void;
  onResolutionFileDrop: (file: File | null) => void;
  onResolutionReasonChange: (
    newResolutionReason: ComboboxOption | null
  ) => void;
  onResolutionRemoveFile: () => void;
  reasonCodeOptions: ComboboxOptions;
  resolutionFile: File | null;
  resolutionReason: ComboboxOption | null;
}

export const CreateResolutionNewWager = ({
  isError,
  onResolutionFileChange,
  onResolutionFileDrop,
  onResolutionReasonChange,
  onResolutionRemoveFile,
  reasonCodeOptions,
  resolutionFile,
  resolutionReason
}: ResolutionUploaderProps) => {
  return (
    <div className="text-soClean-100 flex w-screen max-w-screen-sm flex-col gap-6 p-6">
      <FileHandler
        onFileChange={onResolutionFileChange}
        onFileDrop={onResolutionFileDrop}
        onRemoveFile={onResolutionRemoveFile}
        uploadFile={resolutionFile}
      />
      {isError && (
        <div className="text-status-failure -mt-4 text-xs">
          Error uploading file. Please upload a valid CSV file.
        </div>
      )}
      <div className="flex flex-col gap-1">
        <p className="text-soClean-180 w-full rounded-md text-sm leading-6">
          Reason Code
        </p>
        <div className="border-0">
          <Combobox
            closeMenuOnSelect
            id="resolutionCode"
            isClearable={false}
            isMulti={false}
            onChange={onResolutionReasonChange}
            options={reasonCodeOptions}
            value={resolutionReason}
            valueClassName="py-[11px]"
          />
        </div>
      </div>
    </div>
  );
};
